import { NEWSLETTER_SUCCESS, NEWSLETTER_FAILURE, NEWSLETTER_FETCHING } from '../constants/action_types';
import { postNewsletter } from '../api/api';
import { SubmissionError } from 'redux-form';
import {validate} from "../validators/newsletter";

const newsletterFetching = (email) => ({
    type: NEWSLETTER_FETCHING,
    email
});
const newsletterSuccess = (email) => ({
    type: NEWSLETTER_SUCCESS,
    email
});

const newsletterFailure = (error) => ({
    type: NEWSLETTER_FAILURE,
    error
});

const submitNewsletter = (data) => dispatch => {

    let error = validate(data);
    if(validate(data) == null) {
        dispatch(newsletterFetching());
        return postNewsletter(data)
            .then(res => {
                if (!res.ok) {
                    console.log('!res.ok');
                    return dispatch(newsletterFailure());
                }

                const response = res.body;
                if (!response.valid) {
                    throw new SubmissionError({...response.errors});
                }

                return dispatch(newsletterSuccess(data));
            });
    } else {
        dispatch(newsletterFailure(error));
    }
};


export {
    submitNewsletter
};
